import { render, staticRenderFns } from "./RoomAddOns.vue?vue&type=template&id=1194701c&scoped=true&"
import script from "./RoomAddOns.vue?vue&type=script&lang=js&"
export * from "./RoomAddOns.vue?vue&type=script&lang=js&"
import style0 from "./RoomAddOns.vue?vue&type=style&index=0&id=1194701c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194701c",
  null
  
)

export default component.exports